import { LikeOptions } from "interfaces";
import request from "./request";
const likeService = {
  like: (body: LikeOptions) => request.post("/dashboard/likes", body),
  disLike: (body: LikeOptions) =>
    request.delete(`/dashboard/likes/${body.type_id}?type=${body.type}`),
  likeMany: (body: { types: LikeOptions[] }) =>
    request.post("/dashboard/like/store-many", body),
  getAll: (params?: any) => request.get("/dashboard/likes", { params }),
};
export default likeService;
